module.exports = __webpack_public_path__ + "img/android.ba85a812.svg";